var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none",
  viewBox: "0 0 50 50",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F8491",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.286,
  d: "M25 2v46M2 25h46"
})));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "assets/images/plus.svg";